<script setup lang="ts">
/**
 * Page Footer Component
 *
 * Displays technical support and copyright information.
 * Style: Transparent/light background, centered gray text.
 */
</script>

<template>
  <footer class="w-full bg-transparent py-8 text-center text-xs text-gray-500">
    <!-- Copyright & ICP -->
    <div class="flex flex-col flex-wrap items-center justify-center gap-2 sm:flex-row sm:gap-4">
      <span>©2025 开放原子开源基金会 版权所有</span>
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        class="transition-colors hover:text-gray-700"
      >
        京ICP备2020036654号-4
      </a>
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102011541"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center gap-1 transition-colors hover:text-gray-700"
      >
        <div class="i-carbon-security"></div>
        京公网安备 11030102011541号
      </a>
    </div>
  </footer>
</template>
